<ng-container *ngIf="!big">
    <span class="loader" [class.disabled]="disabled"></span>
</ng-container>

<ng-container *ngIf="big">
    <div class="loader big" [class.no-bg]="noBg"></div>
</ng-container>